import { PropTypes } from 'react';

const TableHeadRow = ({ children }) => (
    <tr className="cn-table__row">{children}</tr>
);

TableHeadRow.propTypes = {
    children: PropTypes.node
};

export default TableHeadRow;



// WEBPACK FOOTER //
// ./app/components/table/head_row.jsx